import styled from 'styled-components';
import DataTable from 'react-data-table-component';

export const Container = styled(DataTable)``;
